import { render, staticRenderFns } from "./AuthMulti.vue?vue&type=template&id=d2a07b2a&"
import script from "./AuthMulti.vue?vue&type=script&lang=js&"
export * from "./AuthMulti.vue?vue&type=script&lang=js&"
import style0 from "./AuthMulti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports